import { Stack } from '@mantine/core';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { AdherenceLog, AdherenceLog as ApiAdherenceLog } from '../../../../api/events-client/events-client.type';
import { EmptyFilterResult } from '../../../../components/filters/empty-filter-result';
import { Table } from '../../../../components/table/table';
import { getAdherenceLogsTableColumns, sortAdherenceLogs } from './adherence-logs-table.helpers';

const ITEMS_PER_PAGE = 25;

type AdherenceLogsTableProps = {
  adherenceLogs: ApiAdherenceLog[] | undefined;
  onAdherenceLogClick?: (log: AdherenceLog) => void;
};

/**
 * Table component for displaying adherence logs
 */
export function AdherenceLogsTable({ adherenceLogs, onAdherenceLogClick }: AdherenceLogsTableProps) {
  const { t } = useTranslation();
  const columns = useMemo(() => getAdherenceLogsTableColumns(t), [t]);
  const [selectedPage, setSelectedPage] = useState(1);

  return (
    <Stack>
      {adherenceLogs && adherenceLogs.length > 0 ? (
        <Table<AdherenceLog>
          data={adherenceLogs}
          columns={columns}
          getRowId={(log: AdherenceLog) => log.id}
          onRowClick={onAdherenceLogClick}
          stickyHeader
          pageSize={ITEMS_PER_PAGE}
          currentPage={selectedPage}
          totalItems={adherenceLogs.length}
          onPageChange={(page: number) => {
            setSelectedPage(page);
          }}
          customSort={sortAdherenceLogs}
        />
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
            minHeight: '300px',
          }}
        >
          <EmptyFilterResult objectName="adherence logs" />
        </div>
      )}
    </Stack>
  );
}
